
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

var script = {
  name: 'PendoPage',
  inject: ['$app'],
  props: {
    backgroundColor: {
      type: String,

      default() {
        return this.$app.pageBackgroundColor;
      }

    }
  },
  computed: {
    pageClasses() {
      return {
        'pendo-page--tabs': this.$app.tabs
      };
    },

    pageStyle() {
      const sidebarWidth = parseInt(this.$app.sidebarWidth);
      const topbarHeight = parseInt(this.$app.topbarHeight);
      return {
        background: this.backgroundColor,
        position: 'fixed',
        top: `${topbarHeight}px`,
        right: '0px',
        height: `calc(100% - ${topbarHeight}px)`,
        overflowY: 'auto',
        overflowX: 'auto',
        minWidth: '0px',
        left: `${sidebarWidth}px`
      };
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('main', {
    staticClass: "pendo-page",
    class: _vm.pageClasses,
    style: _vm.pageStyle
  }, [_c('div', {
    staticClass: "pendo-page-container"
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-page.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoPage = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoPage;
